import client from './client';
import type { EntitlementSnapshot, SubscriptionSnapshot } from './subscription';

export interface BootstrapResponse {
    capabilities?: {
        organize_general_enabled?: boolean;
        similar_item_suggestions_enabled?: boolean;
    };
    user: {
        id: number;
        email: string;
        role?: string | null;
        tier: string;
        plan?: string | null;
        effective_plan?: string | null;
        trial_expires_at?: string | null;
        display_name?: string | null;
        timezone?: string | null;
        avatar_url?: string | null;
        zip_code?: string | null;
        active_domain_key?: string | null;
        onboarding_completed_at?: string | null;
        onboarding_version?: number | null;
        is_auto_sync_enabled?: boolean;
        google_connected?: boolean;
        subscription?: SubscriptionSnapshot | null;
        entitlements?: EntitlementSnapshot | null;
    };
    active_domain_key: string | null;
    active_domain_config: any | null;
    mailbox: {
        connected: boolean;
        primary_email: string | null;
        provider: string | null;
        mailbox_count: number;
        any_syncing: boolean;
        /** @deprecated Same as pre–1.2: sync failures or ERROR mailboxes; excludes REVOKED. */
        any_errors: boolean;
        any_sync_failures: boolean;
        /** True if any mailbox has status ERROR (OAuth broken). Revoked disconnects are excluded. */
        any_connection_errors: boolean;
        max_mailboxes: number | null;
        /** Direct-Gmail reconnect hint when no mailbox is connected (provider migration off). */
        reconnect_email_hint?: string | null;
    };
    subscription?: SubscriptionSnapshot | null;
    entitlements?: EntitlementSnapshot | null;
    needs_onboarding: boolean;
}

export const bootstrapApi = {
    getBootstrap: async (accessToken?: string): Promise<BootstrapResponse> => {
        const res = await client.get('/app/bootstrap', accessToken
            ? {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
            : undefined);
        return res.data;
    },
    updatePreferences: async (payload: { active_domain_key?: string }) => {
        const res = await client.put('/user/preferences', payload);
        return res.data;
    },
    updateProfile: async (payload: { display_name?: string; timezone?: string; avatar_url?: string; zip_code?: string }) => {
        const res = await client.put('/user/profile', payload);
        return res.data;
    },
    completeOnboarding: async (payload: { onboarding_version?: number } = {}) => {
        const res = await client.post('/onboarding/complete', payload);
        return res.data;
    },
};

export default bootstrapApi;
